import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { DroitModel } from 'src/app/shared/models/utilisateur/droit.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { GestionReferentielComponentService } from './gestion-referentiel-component.service';
import { ActiviteModel } from 'src/app/shared/models/simple-types/activite.model';
import { ActiviteService } from 'src/app/shared/services/simple/activite.service';
import { DefinitionDroitsInterface } from 'src/app/shared/droitsDefinitions';

@Component({
  selector: 'app-gestion-referentiel',
  templateUrl: './gestion-referentiel.component.html',
  styleUrls: ['./gestion-referentiel.component.scss']
})
export class GestionReferentielComponent {

  societes: SocieteModel[];
  societesTempon: SocieteModel[];
  societe: SocieteModel;
  droits: DroitModel[];
  droitAdminSociete: DroitModel[] = [];
  droitInterfaceSociete: DroitModel[] = [];
  activites: ActiviteModel[] = [];
  hasDroitInterfaceSage: boolean = false;

  constructor(
    private activiteService: ActiviteService,
    private societeService: SocieteService,
    private toastr: ToastrService,
    private router: Router,
  ) {
    this.droits = JSON.parse(localStorage.getItem('CURRENT_USER')).droits.filter(droit =>
      (droit.niveau === 2) &&
      (droit.type.toUpperCase() === 'ADMIN') &&
      (droit.idSociete === 1)
    );
    // getAll Activites
    this.activiteService.getAll().subscribe(types => {
      this.activites = types;
    });
    this.societeService.getAllFromAdminReferentiel().subscribe(societes => {
      this.societes = societes;
      this.societesTempon = societes;
    });
    this.societe = new SocieteModel();
   }

   onChangeSociete(societe: SocieteModel): void {
    this.hasDroitInterfaceSage = false;
    if (societe) {
      this.societe = this.societesTempon.find((soc: SocieteModel) =>  soc.libelle === societe.libelle);
      this.droitAdminSociete = JSON.parse(localStorage.getItem('CURRENT_USER')).droits.filter(droit =>
        (droit.niveau === 2) &&
        (droit.type.toUpperCase() === 'ADMIN') &&
        (droit.idSociete === societe.id)
      );
      this.droitInterfaceSociete = JSON.parse(localStorage.getItem('CURRENT_USER')).droits.filter(droit =>
        (droit.type.toUpperCase() === 'INTERFACE') &&
        (droit.idSociete === societe.id)
      );
      if (this.droitInterfaceSociete && this.droitInterfaceSociete.length > 0 && this.droitInterfaceSociete.find(droit => droit.niveau === DefinitionDroitsInterface.INTERFACESAGE))
        this.hasDroitInterfaceSage = true;
    }
  }

  close(): void {
    this.router.navigate(['/']);
  }

  onSelectedSociete(objet: string): void {
    if (objet !== undefined) {
      this.societesTempon = this.societes;
      // tslint:disable-next-line: max-line-length
      this.societesTempon = this.societesTempon.filter(obj => (obj.code + " " + obj.libelle).toString().trim().toLowerCase().includes(objet.trim().toLowerCase()));
    }
  }

  navigateSociete(route: string ): void {
    if (this.societe && this.societe.id) {
      this.router.navigate([route, this.societe.id]);
    } else {
      this.toastr.warning('Veuillez selectionnez une société dans la liste');
    }
  }
  navigateGeneral(route: string): void {
      this.router.navigate([route]);
  }

}
